export default {
  data() {
    return {
      errors: [],
    };
  },

  methods: {
    getError(field) {
      return this.errors[field][0] || null;
    },

    hasError(field) {
      return !!this.errors[field];
    },

    clearError(field) {
      if (this.hasError(field)) {
        delete this.errors[field];
      }
    },

    clearAllErrors() {
      this.errors = [];
    },
  },
};
